import React, { ChangeEvent, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useSelector, useDispatch } from 'react-redux';
import {
  createNewSite,
//  editSiteSn,
  addConcentrateurs,  //Contacts
  selectSitesState,
  clearSubmitSiteError,
  updateSiteConcentrateur,
  addModule,
  stopModule,
  replaceModule,
} from '../../redux/slices/sitesSlice';
//import { selectUsersState } from '../../redux/slices/usersSlice';
import { selectContactsState } from '../../redux/slices/contactsSlice';
import { Concentrateur, ConcentrateurPayload, ConcentrateurState, Contact, SiteState } from '../../redux/types';
import ErrorBox from '../../components/ErrorBox';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import InfoIcon from '@material-ui/icons/Info';

import {
  TextField,
  Button,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Avatar,
  Chip,
  InputAdornment,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
  IconButton,
  DialogContent,
  DialogTitle,
  Paper,
  InputLabel,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { useFormStyles, useTableStyles } from '../../styles/muiStyles';
import LabelImportantIcon from '@material-ui/icons/LabelImportant';
import StorageIcon from '@material-ui/icons/Storage';
import SubjectIcon from '@material-ui/icons/Subject';
import AlertIcon from '@material-ui/icons/ReportProblemOutlined';
import Stopped from '@material-ui/icons/BlockOutlined';
import { formatDate } from '../../utils/helperFuncs';
import { Label } from '@material-ui/icons';
import classes from '*.module.css';
import { current } from '@reduxjs/toolkit';
import { AddConcentrateur, editConcentrateur } from '../../redux/slices/concentrateursSlice';
import { Item } from '@adobe/react-spectrum';
import { date } from 'yup/lib/locale';

const validationSchema = yup.object({
  //name: yup
  siteId: yup
    .string()
    .required('Required')
    .max(60, 'Must be at most 60 characters'),
});

interface BaseType {
  closeDialog?: () => void;
}
interface AddConc extends BaseType {
    editMode: 'AddConc';
    currentModules?: string[];
    currentConcentrateurs?: Concentrateur[];
    siteId: string;
}
interface TelConc extends BaseType {
  editMode: 'TelConc';
  currentModules?: string[];
  currentConcentrateurs: Concentrateur[];
  siteId: string;
}
interface StopConc extends BaseType {
    editMode: 'StopConc';
    currentModules?: string[];
    currentConcentrateurs: Concentrateur[];
    siteId: string;
}
interface ReplaceConc extends BaseType {
    editMode: 'ReplaceConc';
    currentModules?: string[];
    currentConcentrateurs: Concentrateur[];
    siteId: string;
}
interface AddModule extends BaseType {
  editMode: 'AddModule';
  currentModules?: string[];
  currentConcentrateurs: Concentrateur[];
  siteId: string;
}
interface StopModule extends BaseType {
    editMode: 'StopModule';
    currentModules?: string[];
    currentConcentrateurs: Concentrateur[];
    siteId: string;
}
interface ReplaceModule extends BaseType {
    editMode: 'ReplaceModule';
    currentModules?: string[];
    currentConcentrateurs: Concentrateur[];// string[];
    siteId: string;
}

type ConcModFormProps = StopConc | ReplaceConc | AddConc | TelConc | StopModule | ReplaceModule | AddModule;

const ConcModForm: React.FC<ConcModFormProps> = ({
  closeDialog,
  editMode,
  currentModules,
  currentConcentrateurs,
  siteId,
}) => {
  const classes = useFormStyles();
  const classes2 = useTableStyles();
  const dispatch = useDispatch();
  const { submitError, submitLoading } = useSelector(selectSitesState);
  const isMobile = false //temporaire
  const { sites /*, fetchStatus, fetchError, sortBy*/ } = useSelector(
    selectSitesState
  );
  const theSiteSn = sites.find((s) => Number(s.id) === Number(siteId))?.sn_site //currentConcentrateurs?.slice()[0]?.site_sn
  function AddModForm() {
    const { register,/* control,*/ handleSubmit, errors } = useForm({
      mode: 'onChange', // onSubmit
      defaultValues:
          { id_module: '', id_conc: ''},
    });
    const [state, setState] = useState({
        selectedConc: currentConcentrateurs !== undefined ? currentConcentrateurs[0] : undefined || undefined,
    });
    const selConcChange = (event: React.ChangeEvent<{  name?: string | undefined; value: unknown; }>) => {
        console.log("################ e.taget.value: "+event.target.value)
        setState({ ...state, [event.target.name as string]: currentConcentrateurs?.find((c)=>c.id === event.target.value )})
    }
    const onSubmit = handleSubmit((data/*{ firstName, lastName, age }*/) => {
      console.log(data)
      dispatch(addModule(siteId, state.selectedConc?.id || 0, data.id_module, closeDialog))
    });

    return (<>
    <form className={classes.concmodzForm} onSubmit={onSubmit}>
      <Table className={classes2.smallFormTable}>
      <TableBody>
      { (currentConcentrateurs !== undefined) && (currentConcentrateurs?.filter((c)=>c.date_end === null).length > 0) ?
        <TableRow>
          <TableCell>
            <div>
            <h3>Concentrateur(s) en cours dans le logement :</h3>
              <p>{currentConcentrateurs
                .filter((cc)=>cc.date_end === null)
                .map((c)=>{ return (
                  <><b>#{c.hardSn}</b> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[ depuis le {c.date_start !== null ? formatDate(c.date_start) : "?"} ] {c.techno}<br/></>
                )})}</p>
            </div>
          </TableCell>
        </TableRow>
        : <div>Pas de concentrateur en cours sur ce logement</div> }
        <TableRow>
          <TableCell>
          <Select fullWidth style={{top: '0.33rem', width: '29.8rem'}} inputRef={register} /*displayEmpty defaultValue={currSite_id}*/
              margin="dense" variant="outlined" onChange={selConcChange} id="selectedConc" 
              className={classes2.demiWidth} name="selectedConc" value={state.selectedConc?.id} >
              {currentConcentrateurs?.map((c) => (
                c.date_end === null ?
                  <MenuItem key={"conc_"+c} value={c.id} {...state.selectedConc?.id === c.id ? 'selected' : null}>
                    <b>{c.hardSn}</b> : {c.date_start !== null ? "depuis le "+formatDate(c.date_start) : "depuis le ?"} (en cours), Tél: {c.tel} {c.techno}</MenuItem>
                  : <MenuItem key={"conc_"+c} value={c.id} {...state.selectedConc?.id === c.id ? 'selected' : null}>
                    <Stopped style={{ top: '0.2em', position: 'relative', right: '0.4rem', marginTop: '-0.5rem'}} />
                      <b>{c.hardSn}</b> : {c.date_start !== null ? "du "+formatDate(c.date_start) : "du ?"} {"au "+formatDate(c.date_end)}, Tél: {c.tel} {c.techno}</MenuItem>
                  //  format(new Date(currDate_start), "yyyy-MM-dd'T'h':'mm")
              ))}
          </Select>
          </TableCell>
        </TableRow>
          <TableRow>
          <TableCell>
          <TextField margin='dense'
            //className={MoreClasses.tiersWidth}
            inputRef={register}
            type="text"
            value={state.selectedConc !== undefined ? String(state.selectedConc?.modules.join(', ')) : null}
            label="Modules actuellement liés"
            variant="outlined"
            fullWidth
            disabled
            style={{top: '0.33rem', width: '14.15rem'}}/>
          </TableCell>
          <TableCell>
          <TextField margin='dense'
            //className={MoreClasses.tiersWidth}
            inputRef={register}
            name="id_module"
            id="id_module"
            type="text"
            label="SN module à ajouter"
            variant="outlined"
            fullWidth
            style={{ marginTop: '1.3em', width: '14.15rem'}}/>
        </TableCell>
      </TableRow>
      <TableRow><TableCell colSpan={2}><h3><InfoIcon style={{top: '0.2rem', position: 'relative'}} />&nbsp;Si besoin d'ajouter plusieurs modules, séparez les par une virgule [1234,5678,8000]</h3></TableCell></TableRow>
      </TableBody>
      </Table>
      <Button
        size="large"
        color="primary"
        variant="contained"
        fullWidth
        style={{top: '0.33rem'}}
        className={classes2.buttons}
        type="submit"
        >
        Ajouter le module au concentrateur sélectionné
      </Button>
    </form>
    {submitError && (
        <ErrorBox
        errorMsg={submitError}
        clearErrorMsg={() => dispatch(clearSubmitSiteError())} />
    )}
    </>
    );
  }
  function StopModForm() {
    const { register,/* control,*/ handleSubmit, errors } = useForm({
      mode: 'onChange', // onSubmit
      defaultValues:
          { date_chgmt: ''},
    });
    const [state, setState] = useState({
        selectedConc: currentConcentrateurs !== undefined ? currentConcentrateurs[0] : undefined || undefined,
        selectedMod: currentModules !== undefined ? currentModules[0] : undefined || undefined,
    });
    const selConcChange = (event: React.ChangeEvent<{  name?: string | undefined; value: unknown; }>) => {
      //console.log("################ e.taget.value: "+event.target.value)
      setState({ ...state, [event.target.name as string]: currentConcentrateurs?.find((c)=>c.id === event.target.value )})
    }
    const selModChange = (event: React.ChangeEvent<{  name?: string | undefined; value: unknown; }>) => {
      console.log("################ e.taget.value: "+event.target.value)
      setState({ ...state, [event.target.name as string]: event.target.value })
    }
    function handleDateChg(evt: { target: { value: any; name: any; }; }) {
      console.log("handleDateChg: "+evt.target.name+" "+evt.target.value);
      const value = evt.target.value;
  /*    console.log("DATE CHANGE VAL: "+value)
      let str = value.replace("T--:--","T12:00")
      console.log("DATE CHANGE VAL: "+str) */
      setState({
        ...state,
        [evt.target.name]: value
      });
    }  
    const onSubmit = handleSubmit((data/*{ firstName, lastName, age }*/) => {
      console.log("Submit StopModule");
      console.log(data)
      dispatch(stopModule(siteId, state.selectedConc?.id || 0, state.selectedMod || "", data.date_chgmt, String(theSiteSn) || '', closeDialog))
    });
    return (<>
      <form className={classes.concmodzForm} onSubmit={onSubmit}>
        <Table className={classes2.smallFormTable}>
        <TableBody>
        { (currentConcentrateurs !== undefined) && (currentConcentrateurs?.filter((c)=>c.date_end === null).length > 0) ?
        <TableRow>
          <TableCell>
            <div>
            <h3>Concentrateur(s) en cours dans le logement :</h3>
              <p>{currentConcentrateurs
                .filter((cc)=>cc.date_end === null)
                .map((c)=>{ return (
                  <><b>#{c.hardSn}</b> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[ depuis le {c.date_start !== null ? formatDate(c.date_start) : "?"} ] {c.techno}<br/></>
                )})}</p>
            </div>
          </TableCell>
        </TableRow>
        : <tr><td><div>Pas de concentrateur en cours sur ce logement</div></td></tr> }
        <TableRow>
          <TableCell>
          <InputLabel>Concentrateur concerné</InputLabel>
          <Select fullWidth style={{top: '0.33rem', width: '29.8rem'}} inputRef={register} /*displayEmpty defaultValue={currSite_id}*/
              margin="dense" variant="outlined" onChange={selConcChange} id="selectedConc" 
              className={classes2.demiWidth} name="selectedConc" value={state.selectedConc?.id} >
              {currentConcentrateurs?.map((c) => (
                c.date_end === null ?
                  <MenuItem key={"conc_"+c} value={c.id} {...state.selectedConc?.id === c.id ? 'selected' : null}>
                    <b>{c.hardSn}</b> : {c.date_start !== null ? "depuis le "+formatDate(c.date_start) : "depuis le ?"} (en cours), Tél: {c.tel} {c.techno}</MenuItem>
                  : <MenuItem key={"conc_"+c} value={c.id} {...state.selectedConc?.id === c.id ? 'selected' : null}>
                    <Stopped style={{ top: '0.2em', position: 'relative', right: '0.4rem', marginTop: '-0.5rem'}} />
                      <b>{c.hardSn}</b> : {c.date_start !== null ? "du "+formatDate(c.date_start) : "du ?"} {"au "+formatDate(c.date_end)}, Tél: {c.tel} {c.techno}</MenuItem>
                  //  format(new Date(currDate_start), "yyyy-MM-dd'T'h':'mm")
              ))}
          </Select>
          </TableCell>
        </TableRow>
            <TableRow>
            <TableCell>
            <InputLabel>Module à arrêter</InputLabel>
            <Select fullWidth style={{top: '0.33rem', width: '29.8rem'}} inputRef={register} /*displayEmpty defaultValue={currSite_id}*/
                margin="dense" variant="outlined" onChange={selModChange} id="selectedMod" 
                className={classes2.demiWidth} name="selectedMod" value={state.selectedMod} >
                {state.selectedConc?.modules.map((mod)=> 
                  state.selectedConc?.date_end === null ?
                    <MenuItem key={"conc_"+state.selectedConc?.id+"_mod_"+mod} value={mod} {...state.selectedMod === String(mod) ? 'selected' : null}>{mod}</MenuItem>
                  : <MenuItem key={"conc_"+state.selectedConc?.id+"_mod_"+mod} value={mod} {...state.selectedMod === String(mod) ? 'selected' : null}>{mod} sur concentrateur arrêté !!?</MenuItem>
                )}
            </Select>
            </TableCell>
            </TableRow>
            <TableRow>
            <TableCell>
            <TextField margin='dense'
              inputRef={register}
              id="date_chgmt"
              name="date_chgmt"
              type="datetime-local"
              label="Date du changement"
              variant="outlined"
              onChange={handleDateChg}
              style={{ marginRight: '8rem', top: '0.53rem', marginTop: '1.1em', float: 'right' }}
              InputLabelProps={{
                shrink: true,
              }}
              />
            </TableCell>
          </TableRow>
        </TableBody>
        </Table>
        <Button
          size="large"
          color="primary"
          variant="contained"
          fullWidth
          style={{top: '0.33rem'}}
          className={classes2.buttons}
          type="submit"
          >
          Arrêter le module sélectionné
        </Button>
      </form>
      {submitError && (
          <ErrorBox
          errorMsg={submitError}
          clearErrorMsg={() => dispatch(clearSubmitSiteError())} />
      )}
      </>
      );
  }
  function ReplaceModForm() {
    const { register,/* control,*/ handleSubmit, errors } = useForm({
      mode: 'onChange', // onSubmit
      defaultValues:
          { date_chgmt: '', id_module: ''},
    });
    const [state, setState] = useState({
        selectedConc: currentConcentrateurs !== undefined ? currentConcentrateurs[0] : undefined || undefined,
        selectedMod: currentModules !== undefined ? currentModules[0] : undefined || undefined,
    });
    const selConcChange = (event: React.ChangeEvent<{  name?: string | undefined; value: unknown; }>) => {
      //console.log("################ e.taget.value: "+event.target.value)
      setState({ ...state, [event.target.name as string]: currentConcentrateurs?.find((c)=>c.id === event.target.value )})
    }
    const selModChange = (event: React.ChangeEvent<{  name?: string | undefined; value: unknown; }>) => {
      console.log("################ e.taget.value: "+event.target.value)
      setState({ ...state, [event.target.name as string]: event.target.value })
    }
    function handleDateChg(evt: { target: { value: any; name: any; }; }) {
      console.log("handleDateChg: "+evt.target.name+" "+evt.target.value);
      const value = evt.target.value;
      setState({
        ...state,
        [evt.target.name]: value
      });
    }  
    const onSubmit = handleSubmit((data/*{ firstName, lastName, age }*/) => {
      console.log("Submit ReplaceModule");
      console.log(data)
      dispatch(replaceModule(siteId, state.selectedConc?.id || 0, state.selectedMod || "", data.id_module, data.date_chgmt, String(theSiteSn) || '', closeDialog))
    });
    return (<>
      <form className={classes.concmodzForm} onSubmit={onSubmit}>
        <Table className={classes2.smallFormTable}>
        <TableBody>
        { (currentConcentrateurs !== undefined) && (currentConcentrateurs?.filter((c)=>c.date_end === null).length > 0) ?
        <TableRow>
          <TableCell>
            <div>
            <h3>Concentrateur(s) en cours dans le logement :</h3>
              <p>{currentConcentrateurs
                .filter((cc)=>cc.date_end === null)
                .map((c)=>{ return (
                  <><b>#{c.hardSn}</b> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[ depuis le {c.date_start !== null ? formatDate(c.date_start) : "?"} ] {c.techno}<br/></>
                )})}</p>
            </div>
          </TableCell>
        </TableRow>
        : <div>Pas de concentrateur en cours sur ce logement</div> }
        <TableRow>
          <TableCell>
          <InputLabel>Concentrateur concerné</InputLabel>
          <Select fullWidth style={{top: '0.33rem', width: '29.8rem'}} inputRef={register} /*displayEmpty defaultValue={currSite_id}*/
              margin="dense" variant="outlined" onChange={selConcChange} id="selectedConc" 
              className={classes2.demiWidth} name="selectedConc" value={state.selectedConc?.id} >
              {currentConcentrateurs?.map((c) => (
                c.date_end === null ?
                  <MenuItem key={"conc_"+c} value={c.id} {...state.selectedConc?.id === c.id ? 'selected' : null}>
                    <b>{c.hardSn}</b> : {c.date_start !== null ? "depuis le "+formatDate(c.date_start) : "depuis le ?"} (en cours), Tél: {c.tel} {c.techno}</MenuItem>
                  : <MenuItem key={"conc_"+c} value={c.id} {...state.selectedConc?.id === c.id ? 'selected' : null}>
                    <Stopped style={{ top: '0.2em', position: 'relative', right: '0.4rem', marginTop: '-0.5rem'}} />
                      <b>{c.hardSn}</b> : {c.date_start !== null ? "du "+formatDate(c.date_start) : "du ?"} {"au "+formatDate(c.date_end)}, Tél: {c.tel} {c.techno}</MenuItem>
                  //  format(new Date(currDate_start), "yyyy-MM-dd'T'h':'mm")
              ))}
          </Select>
          </TableCell>
        </TableRow>
            <TableRow>
            <TableCell>
            <InputLabel>Module à remplacer</InputLabel>
            <Select fullWidth style={{top: '0.33rem', width: '29.8rem'}} inputRef={register} /*displayEmpty defaultValue={currSite_id}*/
                margin="dense" variant="outlined" onChange={selModChange} id="selectedMod" 
                className={classes2.demiWidth} name="selectedMod" value={state.selectedMod} >
                {state.selectedConc?.modules.map((mod)=> 
                  //state.selectedConc?.date_end === null ?
                    <MenuItem key={"conc_"+state.selectedConc?.id+"_mod_"+mod} value={mod} {...state.selectedMod === String(mod) ? 'selected' : null}>{mod}</MenuItem>
                  //: <MenuItem key={"conc_"+state.selectedConc?.id+"_mod_"+mod} value={mod} disabled {...state.selectedMod === String(mod) ? 'selected' : null}>{mod}</MenuItem>
                )}
            </Select>
            </TableCell>
            </TableRow>
            <TableRow>
            <TableCell>
              <TextField margin='dense'
              inputRef={register}
              name="id_module"
              id="id_module"
              type="text"
              label="SN nouveau module"
              variant="outlined"
              fullWidth
              style={{ marginTop: '1.3em', width: '14.15rem'}}/>
            </TableCell>
            <TableCell>
            <TextField margin='dense'
              inputRef={register}
              id="date_chgmt"
              name="date_chgmt"
              type="datetime-local"
              label="Date du changement"
              variant="outlined"
              onChange={handleDateChg}
              style={{ top: '0.29rem', float: 'right' }}
              InputLabelProps={{
                shrink: true,
              }}
              />
            </TableCell>
          </TableRow>
        </TableBody>
        </Table>
        <Button
          size="large"
          color="primary"
          variant="contained"
          fullWidth
          style={{top: '0.33rem'}}
          className={classes2.buttons}
          type="submit"
          >
          Remplacer le module
        </Button>
      </form>
      {submitError && (
          <ErrorBox
          errorMsg={submitError}
          clearErrorMsg={() => dispatch(clearSubmitSiteError())} />
      )}
      </>
      );
  };
  function AddConcForm() {
    const { register,/* control,*/ handleSubmit, errors } = useForm({
      mode: 'onChange', // onSubmit
      defaultValues:
          { 
            date_chgmt: '',
            id_conc: '',
            tel: '',
          },
    });
    const [state, setState] = useState({
        selectedConc: currentConcentrateurs !== undefined ? currentConcentrateurs[0] : undefined || undefined,
    });
    const onSubmit = handleSubmit((data/*{ firstName, lastName, age }*/) => {
      const infos = {
        action: 'addConc',
        concSn: data.id_conc,
        concentrateurSn: String(state.selectedConc?.hardSn) || '',
        concentrateurId: String(state.selectedConc?.id) || '',
        dateChgmt: data.date_chgmt,
        siteId: siteId,
        siteSn: String(theSiteSn)/*String({...state.selectedConc, site_sn})*/ || '',
        tel: data.tel,
        techno: data.tel === "" ? "WIFI" : "LORA",
        modules: '',
      }
      console.log(infos)
      dispatch(updateSiteConcentrateur(siteId, infos, closeDialog))
      //window.location.reload()
    });

    function handleDateChg(evt: { target: { value: any; name: any; }; }) {
      console.log("handleDateChg: "+evt.target.name+" "+evt.target.value);
      const value = evt.target.value;
      setState({
        ...state,
        [evt.target.name]: value
      });
    }
    return (<>
    <form className={classes.concmodzForm} onSubmit={onSubmit}>
      <Table className={classes2.smallFormTable}>
      <TableBody>
      { (currentConcentrateurs !== undefined) && (currentConcentrateurs?.filter((c)=>c.date_end === null).length > 0) ?
        <TableRow>
          <TableCell>
            <div>
            <h3>Concentrateur(s) en cours dans le logement :</h3>
              <p>{currentConcentrateurs
                .filter((cc)=>cc.date_end === null)
                .map((c)=>{ return (
                  <><b>#{c.hardSn}</b> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[ depuis le {c.date_start !== null ? formatDate(c.date_start) : "?"} ] {c.techno}<br/></>
                )})}</p>
            </div>
          </TableCell>
        </TableRow> : 
        <TableRow><TableCell colSpan={2}>Pas de concentrateur en cours sur ce logement</TableCell></TableRow> }
        <TableRow>
          <TableCell>
          <TextField margin='dense'
            //className={MoreClasses.tiersWidth}
            inputRef={register}
            name="id_conc"
            id="id_conc"
            type="text"
            label="SN concentrateur à ajouter"
            variant="outlined"
            fullWidth
            style={{ marginTop: '1.3em', marginLeft: 'auto', marginRight: 'auto', width: '14.15rem'}}/>
        </TableCell>
        <TableCell>
          <TextField margin='dense'
            inputRef={register}
            id="date_chgmt"
            name="date_chgmt"
            type="datetime-local"
            label="Date début"
            variant="outlined"
            onChange={handleDateChg}
            style={{ top: '0.33rem', float: 'right' }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell>
          <TextField margin='dense'
            //className={MoreClasses.tiersWidth}
            inputRef={register}
            name="tel"
            id="tel"
            type="text"
            label="Numéro tél SIM"
            variant="outlined"
            fullWidth
            style={{ marginTop: '1.3em', marginLeft: 'auto', marginRight: 'auto', width: '14.15rem'}}/>
        </TableCell>
        </TableRow>
      </TableBody>
      </Table>
      <Button
        size="large"
        color="primary"
        variant="contained"
        fullWidth
        style={{top: '0.33rem'}}
        className={classes2.buttons}
        type="submit"
        >
        Ajouter le concentrateur
      </Button>
    </form>
    {submitError && (
        <ErrorBox
        errorMsg={submitError}
        clearErrorMsg={() => dispatch(clearSubmitSiteError())} />
    )}
    </>
    );
  }
  function TelConcForm() {
    const { register,/* control,*/ handleSubmit, errors } = useForm({
      mode: 'onChange', // onSubmit
      defaultValues:
          { 
            date_chgmt: '',
            id_conc: '',
            tel: '',
          },
    });
    const [state, setState] = useState({
        selectedConc: currentConcentrateurs !== undefined ? currentConcentrateurs[0] : undefined || undefined,
    });
    const [telValue,setTelvalue] = useState(state.selectedConc?.tel)
    const [wifiValue,setWifiValue] = useState(currentConcentrateurs !== undefined ? 
      //currentConcentrateurs[0].techno === "WIFI" ? true : false
      state.selectedConc?.techno === "WIFI" ? true : false
      : false)
    currentConcentrateurs !== undefined ? 
//      console.log("TECHNO concentrateur: "+currentConcentrateurs[0].techno+" STATE: "+wifiValue) 
      console.log("TECHNO concentrateur: "+state.selectedConc?.techno+" STATE: "+wifiValue) 
      : console.log("TECHNO concentrateur: non défini ??"+" STATE: "+wifiValue)
    
    const selConcChange = (event: React.ChangeEvent<{  name?: string | undefined; value: unknown; }>) => {
      console.log("################ e.taget.value: "+event.target.value)
      setState({ ...state, [event.target.name as string]: currentConcentrateurs?.find((c)=>c.id === event.target.value )})
      setTelvalue(currentConcentrateurs?.find((c)=>Number(c.id) === Number(event.target.value) )?.tel)
      console.log("TECHNO CONCENTRATEUR: "+currentConcentrateurs?.find((c)=>c.id === event.target.value)?.techno)
      /*currentConcentrateurs?.find((c)=>c.id === event.target.value)?.techno === "WIFI" ?
        setWifiValue(true) : setWifiValue(false)*/
      setWifiValue(currentConcentrateurs?.find((c)=>c.id === event.target.value)?.techno === "WIFI" ? true : false)
    }
    function chkboxHandler(event: React.ChangeEvent<{}>) {
      const evt = event as ChangeEvent<HTMLInputElement>
      setState({
        ...state,
        [evt.target.name]: evt.target.checked
      })
      if(evt.target.checked === true ) {
        setWifiValue(true) }
      else {setWifiValue(false)}
    }
    function handleTelChg(evt: { target: { value: any; name: any; }; }) {
      const value = evt.target.value;
      setTelvalue(value)
    }
    const onSubmit = handleSubmit((data/*{ firstName, lastName, age }*/) => {
      const infos = {
        action: 'telConc',
        concSn: '',
        concentrateurSn: String(state.selectedConc?.hardSn) || '',
        concentrateurId: String(state.selectedConc?.id) || '',
        dateChgmt: data.date_chgmt,
        siteId: siteId,
        siteSn: String(state.selectedConc?.site_sn) || '',
        tel: wifiValue === false ? String(telValue) : '',
        techno: wifiValue === true ? "WIFI" : "LORA",
        modules: '',
      }
/*      const conc: ConcentrateurPayload = {
        id: String(state.selectedConc?.id),
        hardSn: String(state.selectedConc?.hardSn),
        tel: wifiValue === false ? String(telValue) : null,
        siteId: siteId,
        date_start: new Date(data.date_chgmt),
        aliasSn: Number(state.selectedConc?.hardSn),
        siteSn: String(state.selectedConc?.site_sn),
        date_end: null, //new Date(),
        ts_last_data: new Date(),
        date_last_data: new Date(),
        pdt: 10,
        modules: state.selectedConc?.modules !== undefined ? state.selectedConc?.modules : [],
        techno: wifiValue === true ? "WIFI" : "LORA",
        version: 0,
      }*/
      console.log(infos)
      dispatch(updateSiteConcentrateur(siteId, infos, closeDialog))
    });

    return (<>
    <form className={classes.concmodzForm} onSubmit={onSubmit}>
      <Table className={classes2.smallFormTable}>
      <TableBody>
        { (currentConcentrateurs !== undefined) && (currentConcentrateurs?.filter((c)=>c.date_end === null).length > 0) ?
        <TableRow>
          <TableCell>
            <div>
            <h3>Concentrateur(s) en cours dans le logement :</h3>
              <p>{currentConcentrateurs
                .filter((cc)=>cc.date_end === null)
                .map((c)=>{ return (
                  <><b>#{c.hardSn}</b> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[ depuis le {c.date_start !== null ? formatDate(c.date_start) : "?"} ] {c.techno}<br/></>
                )})}</p>
            </div>
          </TableCell>
        </TableRow>
        : <div>Pas de concentrateur en cours sur ce logement</div> }
        <TableRow>
          <TableCell>
          <Select fullWidth style={{top: '0.33rem', width: '29.8rem'}} inputRef={register} /*displayEmpty defaultValue={currSite_id}*/
              margin="dense" variant="outlined" onChange={selConcChange} id="selectedConc" 
              className={classes2.demiWidth} name="selectedConc" value={state.selectedConc?.id} >
              {currentConcentrateurs?.map((c) => (
                c.date_end === null ?
                  <MenuItem key={"conc_"+c} value={c.id} {...state.selectedConc?.id === c.id ? 'selected' : null}>
                    <b>{c.hardSn}</b> : {c.date_start !== null ? "depuis le "+formatDate(c.date_start) : "depuis le ?"} (en cours), Tél: {c.tel} {c.techno}</MenuItem>
                  : <MenuItem key={"conc_"+c} value={c.id} {...state.selectedConc?.id === c.id ? 'selected' : null}>
                    <Stopped style={{ top: '0.2em', position: 'relative', right: '0.4rem', marginTop: '-0.5rem'}} />
                      <b>{c.hardSn}</b> : {c.date_start !== null ? "du "+formatDate(c.date_start) : "du ?"} {"au "+formatDate(c.date_end)}, Tél: {c.tel} {c.techno}</MenuItem>
                  //  format(new Date(currDate_start), "yyyy-MM-dd'T'h':'mm")
              ))}
          </Select>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>
            <TextField margin='dense'
              //className={MoreClasses.tiersWidth}
              //inputRef={register}
              name="tel"
              id="tel"
              type="text"
              label="Numéro tél SIM"
              variant="outlined"
              value={/*state.selectedConc?.tel*/telValue}
              onChange={handleTelChg}
              disabled={wifiValue === true ? true : false}
              fullWidth
              style={{ marginTop: '1.3em', marginLeft: 'auto', marginRight: 'auto', width: '14.15rem'}}/>
          </TableCell>
          <TableCell>
          <FormControl style={{display: 'inline-flex', margin: '0.2em 0'}}>
              <FormGroup>
                <FormControlLabel name="wifi" id="wifi" onChange={chkboxHandler} value={wifiValue} 
                  checked={/*state.selectedConc?.techno === "WIFI" ? true : false*/wifiValue === true ? true : false} control={<Checkbox /*inputProps={{ 'aria-label': 'controlled' }}*/></Checkbox>} 
                  label="En Wifi" />
              </FormGroup>
            </FormControl>
          </TableCell>
        </TableRow>
      </TableBody>
      </Table>
      <Button
        size="large"
        color="primary"
        variant="contained"
        fullWidth
        style={{top: '0.33rem'}}
        className={classes2.buttons}
        type="submit"
        >
        Valider les changements
      </Button>
    </form>
    {submitError && (
        <ErrorBox
        errorMsg={submitError}
        clearErrorMsg={() => dispatch(clearSubmitSiteError())} />
    )}
    </>
    );
  }
  function StopConcForm() {
    const { register,/* control,*/ handleSubmit, errors } = useForm({
      mode: 'onChange', // onSubmit
      defaultValues:
          { 
            date_chgmt: '',
          },
    });
    const [state, setState] = useState({
        selectedConc: currentConcentrateurs !== undefined ? currentConcentrateurs[0] : undefined || undefined,
    });
    const selConcChange = (event: React.ChangeEvent<{  name?: string | undefined; value: unknown; }>) => {
        console.log("################ e.taget.value: "+event.target.value)
        setState({ ...state, [event.target.name as string]: currentConcentrateurs?.find((c)=>c.id === event.target.value )})
    }
    function handleDateChg(evt: { target: { value: any; name: any; }; }) {
      console.log("handleDateChg: "+evt.target.name+" "+evt.target.value);
      const value = evt.target.value;
      setState({
        ...state,
        [evt.target.name]: value
      });
    }
    const onSubmit = handleSubmit((data/*{ firstName, lastName, age }*/) => {
      const infos = {
        action: 'stopConc',
        concSn: '',
        concentrateurSn: String(state.selectedConc?.hardSn) || '',
        concentrateurId: String(state.selectedConc?.id) || '',
        dateChgmt: data.date_chgmt,
        siteId: siteId,
        siteSn: String(state.selectedConc?.site_sn) || '',
        tel: '',
        techno: '',
        modules: '',
      }
      console.log(infos)
      dispatch(updateSiteConcentrateur(siteId, infos, closeDialog))
    });
    return (<>
      <form className={classes.concmodzForm} onSubmit={onSubmit}>
        <Table className={classes2.smallFormTable}>
        <TableBody>
        { (currentConcentrateurs !== undefined) && (currentConcentrateurs?.filter((c)=>c.date_end === null).length > 0) ?
        <TableRow>
          <TableCell>
            <div>
            <h3>Concentrateur(s) en cours dans le logement :</h3>
              <ul>{currentConcentrateurs
                .filter((cc)=>cc.date_end === null)
                .map((c)=>{ return (
                  <li key={c.hardSn+"_list"}><b>#{c.hardSn}</b> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[ depuis le {c.date_start !== null ? formatDate(c.date_start) : "?"} ] {c.techno}<br/></li>
                )})}</ul>
            </div>
          </TableCell>
        </TableRow>
        : <div>Pas de concentrateur en cours sur ce logement</div> }
        <TableRow>
          <TableCell>
          <Select fullWidth style={{top: '0.33rem', width: '29.8rem'}} inputRef={register} /*displayEmpty defaultValue={currSite_id}*/
              margin="dense" variant="outlined" onChange={selConcChange} id="selectedConc" 
              className={classes2.demiWidth} name="selectedConc" value={state.selectedConc?.id} >
              {currentConcentrateurs?.map((c) => (
                c.date_end === null ?
                  <MenuItem key={"conc_"+c} value={c.id} {...state.selectedConc?.id === c.id ? 'selected' : null}>
                    <b>{c.hardSn}</b> : {c.date_start !== null ? "depuis le "+formatDate(c.date_start) : "depuis le ?"} (en cours), Tél: {c.tel} {c.techno}</MenuItem>
                  : <MenuItem key={"conc_"+c} value={c.id} {...state.selectedConc?.id === c.id ? 'selected' : null}>
                    <Stopped style={{ top: '0.2em', position: 'relative', right: '0.4rem', marginTop: '-0.5rem'}} />
                      <b>{c.hardSn}</b> : {c.date_start !== null ? "du "+formatDate(c.date_start) : "du ?"} {"au "+formatDate(c.date_end)}, Tél: {c.tel} {c.techno}</MenuItem>
                  //  format(new Date(currDate_start), "yyyy-MM-dd'T'h':'mm")
              ))}
          </Select>
          </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <TextField margin='dense'
                //className={MoreClasses.tiersWidth}
                inputRef={register}
                type="text"
                value={state.selectedConc !== undefined ? String(state.selectedConc?.modules.join(', ')) : null}
                label="Modules actuellement liés"
                variant="outlined"
                fullWidth
                disabled
                style={{top: '0.33rem', width: '14.15rem'}}/>
            </TableCell>
            <TableCell>
              <TextField margin='dense'
                inputRef={register}
                id="date_chgmt"
                name="date_chgmt"
                type="datetime-local"
                label="Date de fin"
                variant="outlined"
                //onChange={handleDateChg}
                style={{ top: '0.33rem', float: 'right' }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </TableCell>
          </TableRow>
        </TableBody>
        </Table>
        <Button
          size="large"
          color="primary"
          variant="contained"
          fullWidth
          style={{top: '0.33rem'}}
          className={classes2.buttons}
          type="submit"
          >
          Arrêter le concentrateur sélectionné
        </Button>
      </form>
      {submitError && (
          <ErrorBox
          errorMsg={submitError}
          clearErrorMsg={() => dispatch(clearSubmitSiteError())} />
      )}
      </>
      );
  }
  function ReplaceConcForm() {
    const { register,/* control,*/ handleSubmit, errors } = useForm({
      mode: 'onChange', // onSubmit
      defaultValues:
          { date_chgmt: '', tel: '', concSn: '' },
    });
    const [state, setState] = useState({
        selectedConc: currentConcentrateurs !== undefined ? currentConcentrateurs[0] : undefined || undefined,
    });
    const selConcChange = (event: React.ChangeEvent<{  name?: string | undefined; value: unknown; }>) => {
        console.log("################ e.taget.value: "+event.target.value)
        setState({ ...state, [event.target.name as string]: currentConcentrateurs?.find((c)=>c.id === event.target.value )})
    }
    function handleDateChg(evt: { target: { value: any; name: any; }; }) {
      console.log("handleDateChg: "+evt.target.name+" "+evt.target.value);
      const value = evt.target.value;
      setState({
        ...state,
        [evt.target.name]: value
      });
    }
    const onSubmit = handleSubmit((data/*{ firstName, lastName, age }*/) => {
      const infos = {
        action: 'replaceConc',
        concSn: data.concSn,
        concentrateurSn: String(state.selectedConc?.hardSn) || '',
        concentrateurId: String(state.selectedConc?.id) || '',
        dateChgmt: data.date_chgmt,
        siteId: siteId,
        siteSn: String(state.selectedConc?.site_sn) || '',
        tel: data.tel,
        techno: '',
        modules: '',
      }
      console.log(infos)
      dispatch(updateSiteConcentrateur(siteId, infos, closeDialog))
    });
    return (<>
      <form className={classes.concmodzForm} onSubmit={onSubmit}>
        <Table className={classes2.smallFormTable}>
        <TableBody>
        { (currentConcentrateurs !== undefined) && (currentConcentrateurs?.filter((c)=>c.date_end === null).length > 0) ?
        <TableRow>
          <TableCell>
            <div>
            <h3>Concentrateur(s) en cours dans le logement :</h3>
              <p>{currentConcentrateurs
                .filter((cc)=>cc.date_end === null)
                .map((c)=>{ return (
                  <><b>#{c.hardSn}</b> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[ depuis le {c.date_start !== null ? formatDate(c.date_start) : "?"} ] {c.techno}<br/></>
                )})}</p>
            </div>
          </TableCell>
        </TableRow>
        : <div>Pas de concentrateur en cours sur ce logement</div> }
        <TableRow>
          <TableCell>
          <Select fullWidth style={{top: '0.33rem', width: '29.8rem'}} inputRef={register} /*displayEmpty defaultValue={currSite_id}*/
              margin="dense" variant="outlined" onChange={selConcChange} id="selectedConc" 
              className={classes2.demiWidth} name="selectedConc" value={state.selectedConc?.id} >
              {currentConcentrateurs?.map((c) => (
                c.date_end === null ?
                  <MenuItem key={"conc_"+c} value={c.id} {...state.selectedConc?.id === c.id ? 'selected' : null}>
                    <b>{c.hardSn}</b> : {c.date_start !== null ? "depuis le "+formatDate(c.date_start) : "depuis le ?"} (en cours), Tél: {c.tel} {c.techno}</MenuItem>
                  : <MenuItem key={"conc_"+c} value={c.id} {...state.selectedConc?.id === c.id ? 'selected' : null}>
                    <Stopped style={{ top: '0.2em', position: 'relative', right: '0.4rem', marginTop: '-0.5rem'}} />
                      <b>{c.hardSn}</b> : {c.date_start !== null ? "du "+formatDate(c.date_start) : "du ?"} {"au "+formatDate(c.date_end)}, Tél: {c.tel} {c.techno}</MenuItem>
                  //  format(new Date(currDate_start), "yyyy-MM-dd'T'h':'mm")
              ))}
          </Select>
          </TableCell>
        </TableRow>
            <TableRow>
            <TableCell>
            <TextField margin='dense'
              //className={MoreClasses.tiersWidth}
              inputRef={register}
              type="text"
              value={state.selectedConc !== undefined ? String(state.selectedConc?.modules.join(', ')) : null}
              label="Modules actuellement liés"
              variant="outlined"
              fullWidth
              disabled
              style={{top: '0.33rem', width: '14.15rem'}}/>
            </TableCell>
            <TableCell>
            <TextField margin='dense'
              inputRef={register}
              id="date_chgmt"
              name="date_chgmt"
              type="datetime-local"
              label="Date du remplacement"
              variant="outlined"
              onChange={handleDateChg}
              style={{ top: '0.33rem', float: 'right' }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>
          <TextField margin='dense'
            //className={MoreClasses.tiersWidth}
            inputRef={register}
            name="concSn"
            id="concSn"
            type="text"
            label="SN nouveau concentrateur"
            variant="outlined"
            fullWidth
            style={{ marginTop: '1.3em', marginLeft: 'auto', marginRight: 'auto', width: '14.15rem'}}/>
        </TableCell>
        <TableCell>
          <TextField margin='dense'
            //className={MoreClasses.tiersWidth}
            inputRef={register}
            name="tel"
            id="tel"
            type="text"
            label="Tél SIM si changement"
            variant="outlined"
            fullWidth
            style={{ marginTop: '1.3em', marginLeft: 'auto', marginRight: 'auto', width: '14.15rem'}}/>
        </TableCell>
        </TableRow>
        </TableBody>
        </Table>
        <Button
          size="large"
          color="primary"
          variant="contained"
          fullWidth
          style={{top: '0.33rem'}}
          className={classes2.buttons}
          type="submit"
          >
          Remplacer le concentrateur sélectionné
        </Button>
      </form>
      {submitError && (
          <ErrorBox
          errorMsg={submitError}
          clearErrorMsg={() => dispatch(clearSubmitSiteError())} />
      )}
      </>
      );
  }
  return (<div>
      {editMode === 'AddModule' ? AddModForm() : null}
      {editMode === 'StopModule' ? StopModForm() : null}
      {editMode === 'ReplaceModule' ? ReplaceModForm() : null}
      {editMode === 'AddConc' ? AddConcForm() : null}
      {editMode === 'TelConc' ? TelConcForm() : null}
      {editMode === 'StopConc' ? StopConcForm() : null}
      {editMode === 'ReplaceConc' ? ReplaceConcForm() : null}
      </div>
    );
};

export default ConcModForm;
